import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { GameDetailsModel } from '@core';
import { ShareGameViewService } from './share-game.view-service';
import { OrIconComponent } from '../or-icon/or-icon.component';

@Component({
  selector: 'lib-share-game',
  templateUrl: './share-game.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [OrIconComponent],
  providers: [ShareGameViewService]
})
export class ShareGameComponent {
  // Note: Using @Input() because component is used via Ionic modal componentProps
  @Input({ required: true }) game!: GameDetailsModel;

  private readonly shareGameViewService: ShareGameViewService = inject(ShareGameViewService);

  copyGameUrl(): void {
    this.shareGameViewService.copyGameLink(this.game?.gameId);
  }

  copySocialContent(): void {
    this.shareGameViewService.copySocialContent(this.game).subscribe();
  }

  openAdvancedSharing(): void {
    this.shareGameViewService.advancedShareNative(this.game);
  }
}
